module.exports = "chat-messages {\n  height: 400px; }\n"